import React from "react";
import './style/slider.scss';
import {Grid} from '@material-ui/core';
import { FiChevronLeft,FiChevronRight } from "react-icons/fi";
import Gallery from "../../models/gallery.model";

interface ISInterface{
  images:Array<Gallery>,
  active:number | null,
  previous:()=>void,
  next:()=>void,
}



const ImgSlider:React.FC<ISInterface> = props =>{
  const {images,active,previous,next} = props;
  return(
    <Grid item xs={12} md={8}>
      <div className="ecn-lb-slider">
        {
          images.map((img,i)=>(
            <div className={i===active?"ecn-lb-slider-item active":"ecn-lb-slider-item"} key={i}>
              <img src={img.value} alt="" className="img-fluid"/>
            </div>
          ))
        }
        
      </div>

      <FiChevronLeft className="ecn-lb-slider-nav left" onClick={previous}/>
      <FiChevronRight className="ecn-lb-slider-nav right" onClick={next}/>
    </Grid>
  )
}
export default ImgSlider;